import {
  AppstoreOutlined,
  BellOutlined,
  CodeOutlined,
  DatabaseOutlined,
  DownOutlined,
  FolderOutlined,
  LoadingOutlined,
  LogoutOutlined,
  MenuOutlined,
  PinterestOutlined,
  ReloadOutlined,
  SearchOutlined,
  SettingOutlined,
  StarOutlined,
  SwitcherOutlined,
  UserOutlined,
  SunOutlined,
  MoonOutlined,
  DeleteOutlined,
  EditOutlined,
  PlusOutlined,
  GlobalOutlined,
  CommentOutlined,
  SafetyOutlined,
  UsergroupAddOutlined,
  ToolOutlined,
  CloseOutlined,
  MoreOutlined,
  LockOutlined,
} from "@ant-design/icons";
import {
  Avatar,
  Button,
  Dropdown,
  Input,
  Layout,
  Menu,
  message,
  Space,
  Spin,
  Tag,
  Tooltip,
  Popover,
  Card,
  List,
  Typography,
  Modal,
  Form,
  Input as AntdInput,
  Badge,
  Drawer,
  Grid,
} from "antd";
import { useEffect, useState } from "react";
import { useMenu } from "../../store/context/admin/menu-context";
import { useRouteHistory } from "../../store/context/admin/route-history-context";
import { useTenant } from "../../store/context/tenant-context";
import { postAuthenticatedRequest } from "../../utils/api/requests/request";
import ServerStatusDrawer from "../Settings/DeveloperTools/Tabs/modals/ServerStatus";
import NavigatorModal from "./menu_tree";
import NotificationDrawer from "./notification";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { getSessionData } from "../../utils/interceptors/localStorageService";
import {
  PERMISSION_CODES,
  SelfUserClassificationEnum,
  UserPreferenceEnum,
  featuresEnum,
  PermissionsEnum,
  SelfServiceAccountTypeEnum,
} from "../../shared/constants/constants";
import { logoutUser } from "../../store/redux/actions/userActions";
import { navigateToAuth } from "../../utils/helper/redirect";
import CommandDrawer from "../Settings/DeveloperTools/Tabs/modals/CommandDrawer";
import { useLanguage } from "../../store/context/language-context";
import { useUserPreference } from "../../store/context/user-preference-context";
import { useTheme } from "../../store/context/theme-context";
import { usePermissions } from "../../store/context/permission-context";
import { useFeatures } from "../../store/context/feature-context";
import LanguageSwitcher from "../../shared/languages/LanguageSwitcher";
import CountrySupportModal from "../../shared/common/CountrySupportModal";

const { SubMenu } = Menu;
const { Header } = Layout;
const { Search } = Input;
const { Text } = Typography;
const { useBreakpoint } = Grid;

// Cache constants
const FAVORITES_TTL = 24 * 60 * 60 * 1000; // 24 hours in milliseconds
const FAVORITES_CACHE_KEY = 'favorites_cache_v2';
const LAST_SYNC_TIME_KEY = 'favorites_last_sync';

// Helper functions for caching
const getCachedFavorites = () => {
  try {
    const cached = localStorage.getItem(FAVORITES_CACHE_KEY);
    if (!cached) return [];
    
    const parsed = JSON.parse(cached);
    // Handle both new format (with timestamp) and old format (just array)
    return Array.isArray(parsed) ? parsed : parsed.data || [];
  } catch (error) {
    console.error("Error reading favorites cache:", error);
    return [];
  }
};

const updateCache = (favorites) => {
  try {
    const cacheData = {
      data: favorites,
      timestamp: Date.now(),
      version: 'v2'
    };
    localStorage.setItem(FAVORITES_CACHE_KEY, JSON.stringify(cacheData));
    return true;
  } catch (error) {
    console.error("Error caching favorites:", error);
    return false;
  }
};

const shouldSyncWithBackend = () => {
  try {
    const lastSync = localStorage.getItem(LAST_SYNC_TIME_KEY);
    if (!lastSync) return true;
    
    const lastSyncTime = parseInt(lastSync);
    const now = Date.now();
    
    // Sync if TTL has expired
    return (now - lastSyncTime) > FAVORITES_TTL;
  } catch (error) {
    console.error("Error checking sync time:", error);
    return true;
  }
};

const updateLastSyncTime = () => {
  localStorage.setItem(LAST_SYNC_TIME_KEY, Date.now().toString());
};

const clearCache = () => {
  localStorage.removeItem(FAVORITES_CACHE_KEY);
  localStorage.removeItem(LAST_SYNC_TIME_KEY);
};

const DashboardHeader = ({ collapsed, onMenuClick }) => {
  const screens = useBreakpoint();
  const { language, setLanguage } = useLanguage();
  const { theme, toggleTheme } = useTheme();
  const { updateUserPreference, userPreferences, getUserPreference } = useUserPreference();
  const { findPermission, hasPermission } = usePermissions();
  const { findFeature } = useFeatures();
  const { isModalOpen, showModal } = useLanguage();
  const [isOpen, setIsOpen] = useState(false);
  const sessionData = getSessionData();
  const [searchExpanded, setSearchExpanded] = useState(false);
  const [isNavigatorOpen, setIsNavigatorOpen] = useState(false);
  const [selectedBranch, setSelectedBranch] = useState();
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isCommandDrawerOpen, setIsCommandDrawerOpen] = useState(false);
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // Responsive states
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isSearchMobile, setIsSearchMobile] = useState(false);

  // Favorites states
  const [favorites, setFavorites] = useState([]);
  const [isFavoritesOpen, setIsFavoritesOpen] = useState(false);
  const [isEditingFavorite, setIsEditingFavorite] = useState(false);
  const [editingFavorite, setEditingFavorite] = useState(null);
  const [favoriteName, setFavoriteName] = useState('');
  const [isSyncing, setIsSyncing] = useState(false);

  // Helper function for consistent button styling
  const getModernButtonStyle = (active = false) => ({
    color: "white",
    fontSize: "16px",
    width: "32px",
    height: "32px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "6px",
    backgroundColor: active ? "rgba(255, 255, 255, 0.2)" : "transparent",
    border: "none",
    padding: 0,
  });

  const handleButtonHover = (e, isEntering) => {
    if (isEntering) {
      e.currentTarget.style.backgroundColor = "rgba(255, 255, 255, 0.15)";
    } else {
      const isActive = e.currentTarget.dataset.active === "true";
      e.currentTarget.style.backgroundColor = isActive ? "rgba(255, 255, 255, 0.2)" : "transparent";
    }
  };

  const isAdmin =
    sessionData?.userClassification ===
    SelfUserClassificationEnum.BACKOFFICE_ADMINISTRATORS.value;

  // Dynamic branch states
  const [branches, setBranches] = useState([]);
  const [isLoadingBranches, setIsLoadingBranches] = useState(false);
  const [pagination] = useState({
    pageNumber: 1,
    pageSize: 100,
  });
  const [serverLanguages, setServerLanguages] = useState([]);
  const [tenantInformation, setTenantInformtion] = useState([]);
  const tenant = useTenant();
  const { setUseV2Design, useV2Design, menuList } = useMenu();
  const history = useRouteHistory();

  // Responsive helpers
  const isMobile = !screens.md;
  const isTablet = screens.md && !screens.lg;
  const isDesktop = screens.lg;

  // Load favorites on component mount
  useEffect(() => {
    if (useV2Design) {
      loadFavorites();
      getAllBranches();
      getAllLanguages();
      getPlatformConfig();
    }
  }, [useV2Design]);

  // Responsive search behavior
  useEffect(() => {
    if (isMobile && searchExpanded) {
      setIsSearchMobile(true);
    }
  }, [isMobile, searchExpanded]);

  // Load favorites from cache
  const loadFavorites = async () => {
    try {
      // Always load from cache first for instant UI
      const cachedFavorites = getCachedFavorites();
      setFavorites(cachedFavorites);
      
      // Check if we need to sync with backend
      if (shouldSyncWithBackend()) {
        syncFavoritesWithBackend();
      }
    } catch (error) {
      console.error("Error loading favorites:", error);
      setFavorites([]);
    }
  };

  // Sync favorites with backend (only when needed)
  const syncFavoritesWithBackend = async () => {
    try {
      setIsSyncing(true);
      
      // Get current favorites from cache
      const cachedFavorites = getCachedFavorites();
      
      // Try to get from backend
      const backendFavorites = await getUserPreference(UserPreferenceEnum.FAVOURITE_ROUTES);
      
      if (backendFavorites && Array.isArray(backendFavorites)) {
        // If backend has data, merge with cache (favor cache for conflicts)
        const mergedFavorites = mergeFavorites(cachedFavorites, backendFavorites);
        
        // Update backend with merged data
        const success = await updateUserPreference(UserPreferenceEnum.FAVOURITE_ROUTES, mergedFavorites);
        
        if (success?.outData?.isSuccessful) {
          // Update cache with merged data
          updateCache(mergedFavorites);
          setFavorites(mergedFavorites);
          updateLastSyncTime();
          
          if (cachedFavorites.length !== mergedFavorites.length) {
            message.info('Favorites synced with server');
          }
        }
      } else if (cachedFavorites.length > 0) {
        // Backend has no data, but cache does - save cache to backend
        const success = await updateUserPreference(UserPreferenceEnum.FAVOURITE_ROUTES, cachedFavorites);
        
        if (success?.outData?.isSuccessful) {
          updateLastSyncTime();
          message.info('Favorites saved to server');
        }
      }
    } catch (error) {
      console.error("Error syncing favorites:", error);
      // Don't show error to user - just use cache
    } finally {
      setIsSyncing(false);
    }
  };

  // Merge cache and backend favorites (cache wins on conflicts)
  const mergeFavorites = (cacheFavorites, backendFavorites) => {
    const cacheMap = new Map(cacheFavorites.map(fav => [fav.path, fav]));
    const backendMap = new Map(backendFavorites.map(fav => [fav.path, fav]));
    
    // Start with cache favorites
    const merged = [...cacheFavorites];
    
    // Add backend favorites that aren't in cache
    backendFavorites.forEach(backendFav => {
      if (!cacheMap.has(backendFav.path)) {
        merged.push(backendFav);
      }
    });
    
    return merged;
  };

  // Update favorites in cache immediately
  const updateFavorites = (updatedFavorites) => {
    // Update cache immediately
    updateCache(updatedFavorites);
    
    // Update state
    setFavorites(updatedFavorites);
    
    // Check if we need to sync with backend
    if (shouldSyncWithBackend()) {
      // Start async sync
      syncFavoritesWithBackend().catch(() => {
        // Silently fail - cache is already updated
      });
    }
    
    return true;
  };

  // Add current page to favorites
  const handleAddToFavorites = () => {
    const currentPath = window.location.pathname + window.location.search;
    const currentTitle = document.title || "Current Page";

    // Check if already favorited
    const isAlreadyFavorited = favorites.some(fav => fav.path === currentPath);
    if (isAlreadyFavorited) {
      message.warning("This page is already in your favorites!");
      return;
    }

    const newFavorite = {
      id: Date.now().toString(),
      name: currentTitle,
      path: currentPath,
      icon: "star",
      createdAt: new Date().toISOString(),
      lastAccessed: new Date().toISOString(),
    };

    const updatedFavorites = [...favorites, newFavorite];
    
    // Update cache immediately
    updateFavorites(updatedFavorites);
    message.success("Added to favorites!");
    
    // Auto-open the favorites dropdown on desktop
    if (!isMobile) {
      setIsFavoritesOpen(true);
    }
  };

  // Remove favorite
  const handleRemoveFavorite = async (id, e) => {
    if (e) e.stopPropagation();

    Modal.confirm({
      title: 'Remove Favorite',
      content: 'Are you sure you want to remove this favorite?',
      okText: 'Yes, remove',
      okType: 'danger',
      cancelText: 'Cancel',
      onOk: () => {
        const updatedFavorites = favorites.filter(fav => fav.id !== id);
        updateFavorites(updatedFavorites);
        message.success("Removed from favorites");
      }
    });
  };

  // Edit favorite name
  const handleEditFavorite = (favorite, e) => {
    if (e) e.stopPropagation();
    setEditingFavorite(favorite);
    setFavoriteName(favorite.name);
    setIsEditingFavorite(true);
  };

  // Save edited favorite
  const handleSaveEditFavorite = async () => {
    if (!favoriteName.trim()) {
      message.warning("Favorite name cannot be empty");
      return;
    }

    const updatedFavorites = favorites.map(fav =>
      fav.id === editingFavorite.id ? { ...fav, name: favoriteName.trim() } : fav
    );

    updateFavorites(updatedFavorites);
    message.success("Favorite updated!");
    setIsEditingFavorite(false);
    setEditingFavorite(null);
    setFavoriteName('');
  };

  // Navigate to favorite
  const handleNavigateToFavorite = (favorite) => {
    navigate(favorite.path);
    setIsFavoritesOpen(false);
    setIsMobileMenuOpen(false);

    // Update last accessed time
    const updatedFavorites = favorites.map(fav =>
      fav.id === favorite.id ? { ...fav, lastAccessed: new Date().toISOString() } : fav
    );
    updateFavorites(updatedFavorites);
  };

  // Sort favorites by last accessed (most recent first)
  const sortedFavorites = [...favorites].sort((a, b) =>
    new Date(b.lastAccessed) - new Date(a.lastAccessed)
  );

  // Favorites dropdown content for desktop
  const favoritesContent = (
    <Card
      style={{
        width: isMobile ? 280 : 320,
        maxHeight: 400,
        overflow: 'auto',
        boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
      }}
      bodyStyle={{ padding: '12px' }}
      size="small"
    >
      <div style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: 12,
        paddingBottom: 8,
        borderBottom: `1px solid ${theme === 'dark' ? '#303030' : '#f0f0f0'}`
      }}>
        <Text strong style={{ fontSize: '14px' }}>
          <StarOutlined style={{ marginRight: 8, color: '#faad14' }} />
          Favorites ({favorites.length})
        </Text>
        <Button
          type="text"
          size="small"
          icon={<PlusOutlined />}
          onClick={handleAddToFavorites}
          loading={isSyncing}
        >
          {isMobile ? "Add" : "Add Current"}
        </Button>
      </div>

      {favorites.length === 0 ? (
        <div style={{
          textAlign: "center",
          padding: '24px 0',
          color: '#999'
        }}>
          <StarOutlined style={{ fontSize: 24, marginBottom: 8, opacity: 0.5 }} />
          <div>No favorites yet</div>
          <div style={{ fontSize: 12, marginTop: 4 }}>
            Click "Add Current" to bookmark this page
          </div>
        </div>
      ) : (
        <>
          {isSyncing && (
            <div style={{ textAlign: 'center', marginBottom: 8 }}>
              <Spin size="small" /> Syncing...
            </div>
          )}
          <List
            size="small"
            dataSource={sortedFavorites}
            renderItem={(favorite) => (
              <List.Item
                style={{
                  padding: '8px 4px',
                  cursor: 'pointer',
                  borderRadius: 4,
                  marginBottom: 4,
                }}
                actions={!isMobile ? [
                  <Tooltip title="Edit">
                    <Button
                      type="text"
                      size="small"
                      icon={<EditOutlined />}
                      onClick={(e) => handleEditFavorite(favorite, e)}
                    />
                  </Tooltip>,
                  <Tooltip title="Delete">
                    <Button
                      type="text"
                      size="small"
                      danger
                      icon={<DeleteOutlined />}
                      onClick={(e) => handleRemoveFavorite(favorite.id, e)}
                    />
                  </Tooltip>
                ] : []}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = theme === 'dark' ? '#303030' : '#f5f5f5';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = 'transparent';
                }}
                onClick={() => handleNavigateToFavorite(favorite)}
              >
                <List.Item.Meta
                  avatar={<StarOutlined style={{ color: '#faad14' }} />}
                  title={
                    <Text
                      ellipsis
                      style={{
                        maxWidth: isMobile ? 180 : 200,
                        fontSize: '13px'
                      }}
                    >
                      {favorite.name}
                    </Text>
                  }
                  description={
                    <Text
                      type="secondary"
                      ellipsis
                      style={{
                        maxWidth: isMobile ? 180 : 200,
                        fontSize: '11px'
                      }}
                    >
                      {favorite.path.length > (isMobile ? 30 : 40) ?
                        `${favorite.path.substring(0, isMobile ? 30 : 40)}...` :
                        favorite.path
                      }
                    </Text>
                  }
                />
              </List.Item>
            )}
          />
        </>
      )}
    </Card>
  );

  // Mobile favorites drawer
  const mobileFavoritesDrawer = (
    <Drawer
      title={
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <span>
            <StarOutlined style={{ marginRight: 8, color: '#faad14' }} />
            Favorites ({favorites.length})
          </span>
          <Button
            type="primary"
            size="small"
            icon={<PlusOutlined />}
            onClick={handleAddToFavorites}
            loading={isSyncing}
          >
            Add Current
          </Button>
        </div>
      }
      placement="right"
      onClose={() => setIsFavoritesOpen(false)}
      open={isFavoritesOpen && isMobile}
      width={320}
    >
      {favorites.length === 0 ? (
        <div style={{
          textAlign: "center",
          padding: '40px 0',
          color: '#999'
        }}>
          <StarOutlined style={{ fontSize: 48, marginBottom: 16, opacity: 0.5 }} />
          <div style={{ fontSize: 16, marginBottom: 8 }}>No favorites yet</div>
          <div style={{ fontSize: 14, color: '#666' }}>
            Add your frequently visited pages here for quick access
          </div>
          <Button
            type="primary"
            icon={<PlusOutlined />}
            style={{ marginTop: 24 }}
            onClick={handleAddToFavorites}
            loading={isSyncing}
          >
            Add Current Page
          </Button>
        </div>
      ) : (
        <>
          {isSyncing && (
            <div style={{ textAlign: 'center', marginBottom: 16, padding: '8px' }}>
              <Spin size="small" /> Syncing with server...
            </div>
          )}
          <List
            dataSource={sortedFavorites}
            renderItem={(favorite) => (
              <List.Item
                style={{
                  padding: '12px 0',
                  borderBottom: '1px solid #f0f0f0',
                  cursor: 'pointer',
                }}
                actions={[
                  <Button
                    type="text"
                    icon={<EditOutlined />}
                    onClick={(e) => handleEditFavorite(favorite, e)}
                  />,
                  <Button
                    type="text"
                    danger
                    icon={<DeleteOutlined />}
                    onClick={(e) => handleRemoveFavorite(favorite.id, e)}
                  />
                ]}
                onClick={() => handleNavigateToFavorite(favorite)}
              >
                <List.Item.Meta
                  avatar={<StarOutlined style={{ color: '#faad14', fontSize: 16 }} />}
                  title={
                    <Text ellipsis style={{ fontSize: '14px' }}>
                      {favorite.name}
                    </Text>
                  }
                  description={
                    <Text
                      type="secondary"
                      ellipsis
                      style={{
                        fontSize: '12px',
                        display: 'block'
                      }}
                    >
                      {favorite.path.length > 40 ?
                        `${favorite.path.substring(0, 40)}...` :
                        favorite.path
                      }
                    </Text>
                  }
                />
              </List.Item>
            )}
          />
        </>
      )}
    </Drawer>
  );

  // Edit favorite modal
  const editFavoriteModal = (
    <Modal
      title="Edit Favorite Name"
      open={isEditingFavorite}
      onOk={handleSaveEditFavorite}
      onCancel={() => {
        setIsEditingFavorite(false);
        setEditingFavorite(null);
        setFavoriteName('');
      }}
      okText="Save"
      cancelText="Cancel"
      width={isMobile ? "90%" : 520}
    >
      <Form layout="vertical">
        <Form.Item label="Favorite Name">
          <AntdInput
            value={favoriteName}
            onChange={(e) => setFavoriteName(e.target.value)}
            placeholder="Enter favorite name"
            autoFocus
            onPressEnter={handleSaveEditFavorite}
            maxLength={100}
          />
        </Form.Item>
        {editingFavorite && (
          <Form.Item label="URL">
            <AntdInput
              value={editingFavorite.path}
              disabled
              style={{ fontSize: '12px' }}
            />
          </Form.Item>
        )}
      </Form>
    </Modal>
  );

  const handleSignOut = () => {
    // Force sync before logout if needed
    if (shouldSyncWithBackend()) {
      syncFavoritesWithBackend().finally(() => {
        clearCache();
        dispatch(logoutUser());
        isAdmin
          ? navigateToAuth({ isAdmin: true })
          : navigateToAuth({ isAdmin: false });
      });
    } else {
      clearCache();
      dispatch(logoutUser());
      isAdmin
        ? navigateToAuth({ isAdmin: true })
        : navigateToAuth({ isAdmin: false });
    }
  };

  const isDeveloperToolsManager = hasPermission(
    PERMISSION_CODES.BPM_MANAGEMENT.DEVELOPER_TOOLS_MANAGER
  );

  // Settings submenu click handlers
  const handleSettingsSubMenuClick = ({ key }) => {
    switch (key) {
      case "notifications":
        navigate("/settings/notifications");
        break;
      case "change-language":
        showModal();
        break;
      case "get-in-touch":
        setIsOpen(true);
        break;
      case "security":
        if (isAdmin) {
          navigate("/settings/security/change-password");
        } else {
          navigate("/settings/security");
        }
        break;
      case "change-password":
        navigate("/settings/security/change-password");
        break;
      case "users":
        navigate("/settings/all-users");
        break;
      default:
        break;
    }
    setIsMobileMenuOpen(false);
  };

  // Custom function to fetch branches
  const getAllBranches = async (paginationData = pagination) => {
    try {
      setIsLoadingBranches(true);
      const response = await postAuthenticatedRequest(
        "RetrieveBranchesListQuery",
        {
          pageNumber: paginationData.pageNumber,
          pageSize: paginationData.pageSize,
        }
      );

      if (response?.outData?.isSuccessful) {
        const branchData = response?.outData?.data?.items ?? [];
        const transformedBranches = branchData.map((branch) => ({
          key: branch.id || branch.branchId || branch.code,
          label: branch.name || branch.branchName || branch.displayName,
          ...branch,
        }));

        setBranches(transformedBranches);
        if (transformedBranches.length > 0 && !selectedBranch) {
          setSelectedBranch(transformedBranches[0].key);
        }
      } else {
        setBranches([]);
      }
    } catch (error) {
      console.error("Error fetching branches:", error);
      setBranches([]);
    } finally {
      setIsLoadingBranches(false);
    }
  };

  const getAllLanguages = async () => {
    try {
      const response = await postAuthenticatedRequest(
        "LookupLanguagesQuery",
        {}
      );
      if (response?.outData?.isSuccessful) {
        const languageData = response?.outData?.data ?? [];
        setServerLanguages(languageData);
      } else {
        setServerLanguages([]);
      }
    } catch (error) {
      console.error("Error fetching languages:", error);
    }
  };

  const getPlatformConfig = async () => {
    try {
      const response = await postAuthenticatedRequest("GetConfigQuery", {
        path: "platform.tenantInformation",
        configName: "GeneralConfiguration",
      });
      if (response?.outData?.isSuccessful) {
        const data = response?.outData?.data ?? [];
        setTenantInformtion(data);
      } else {
        setTenantInformtion({});
      }
    } catch (error) {
      console.error("Error fetching tenant info:", error);
    }
  };

  const showDrawer = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  const handleMenuClick = ({ key }) => {
    switch (key) {
      case "switcher":
        setUseV2Design(!useV2Design);
        break;
      case "profile":
        navigate("/settings/profile");
        break;
      case "settings":
        navigate("/settings");
        break;
      case "theme": {
        const newTheme = theme === "dark" ? "light" : "dark";
        toggleTheme();
        updateUserPreference(UserPreferenceEnum.THEME, newTheme);
        break;
      }
      case "logout":
        handleSignOut();
        break;
      default:
        break;
    }
    setIsMobileMenuOpen(false);
  };

  const handleBranchSelect = ({ key }) => {
    setSelectedBranch(key);
    const selectedBranchData = branches.find((branch) => branch.key === key);
    message.success(`Switched to branch: ${selectedBranchData?.label || key}`);
  };

  const handleRefreshBranches = () => {
    getAllBranches();
  };

  const handleLanguageChange = (item) => {
    const newLanguage = item.key;
    setLanguage(newLanguage);
    updateUserPreference(UserPreferenceEnum.LANGUAGE, newLanguage);
  };

  // Build settings submenu items based on permissions and user type
  const buildSettingsSubMenu = () => {
    const subMenuItems = [];

    // Notifications item
    if (findPermission(PermissionsEnum.ADM_NOTIFICATIONS)) {
      subMenuItems.push({
        key: "notifications",
        icon: <BellOutlined />,
        label: "Notifications",
      });
    }

    // Change Language item
    subMenuItems.push({
      key: "change-language",
      icon: <GlobalOutlined />,
      label: "Change Language",
    });

    // Get In Touch item
    subMenuItems.push({
      key: "get-in-touch",
      icon: <CommentOutlined />,
      label: "Get In Touch",
    });

    // Security/Change Password item - Different for admin
    subMenuItems.push({
      key: isAdmin ? "change-password" : "security",
      icon: isAdmin ? <LockOutlined /> : <SafetyOutlined />,
      label: isAdmin ? "Change Password" : "Security",
    });

    // Users item (conditionally added)
    const showUsersItem = (sessionData?.userClassification ===
      SelfUserClassificationEnum.BACKOFFICE_ADMINISTRATORS.value ||
      sessionData?.accountType ===
      SelfServiceAccountTypeEnum.CORPORATE.value) &&
      hasPermission(PERMISSION_CODES.USER_MANAGEMENT.VIEW_USERS);

    if (showUsersItem) {
      subMenuItems.push({
        key: "users",
        icon: <UsergroupAddOutlined />,
        label: "Users",
      });
    }

    return subMenuItems;
  };

  // Updated user menu with settings submenu
  const userMenu = (
    <Menu onClick={handleMenuClick}>
      <Menu.Item
        disabled={!useV2Design}
        key="switcher"
        icon={<SwitcherOutlined />}
      >
        Switch Layout ({useV2Design ? "V1" : "V2"})
      </Menu.Item>
      <Menu.Item key="profile" icon={<UserOutlined />}>
        Profile
      </Menu.Item>

      {/* Favorites in user menu for mobile context */}
      {isMobile && (
        <Menu.Item
          key="favorites"
          icon={<StarOutlined />}
          onClick={() => {
            setIsFavoritesOpen(true);
            setIsMobileMenuOpen(false);
          }}
        >
          Favorites ({favorites.length})
        </Menu.Item>
      )}

      {/* Settings - Direct navigation to settings page (no submenu) */}
      <Menu.Item key="settings" icon={<SettingOutlined />}>
        Settings
      </Menu.Item>

      <Menu.Item
        key="theme"
        icon={theme === "dark" ? <SunOutlined /> : <MoonOutlined />}
      >
        {theme === "dark" ? "Light Mode" : "Dark Mode"}
      </Menu.Item>
      <Menu.Divider />
      <Menu.Item key="logout" icon={<LogoutOutlined />}>
        Logout
      </Menu.Item>
    </Menu>
  );

  // Branch menu
  const branchMenu = (
    <Menu onClick={handleBranchSelect}>
      {isLoadingBranches ? (
        <Menu.Item key="loading" disabled>
          <Spin size="small" /> Loading branches...
        </Menu.Item>
      ) : (
        <>
          {branches.length > 0 ? (
            branches.map((branch) => (
              <Menu.Item key={branch.key}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <span>{branch.label}</span>
                  {branch.key === selectedBranch && (
                    <Tag color="green" size="small">
                      Current
                    </Tag>
                  )}
                </div>
              </Menu.Item>
            ))
          ) : (
            <Menu.Item key="no-branches" disabled>
              No branches available
            </Menu.Item>
          )}
          <Menu.Divider />
          <Menu.Item key="refresh" onClick={handleRefreshBranches}>
            <ReloadOutlined /> Refresh Branches
          </Menu.Item>
        </>
      )}
    </Menu>
  );

  // Responsive search handlers
  const handleSearchToggle = () => {
    if (isMobile) {
      setIsSearchMobile(!isSearchMobile);
    } else {
      setSearchExpanded(!searchExpanded);
    }
  };

  const handleSearchBlur = () => {
    if (isMobile) {
      setIsSearchMobile(false);
    } else {
      setSearchExpanded(false);
    }
  };

  const renderMenu = (items) => {
    return [...items]
      .sort((a, b) => a.label.localeCompare(b.label))
      .map((item) => {
        if (item.submenus && item.submenus.length > 0) {
          return (
            <SubMenu key={item.key} title={item.label}>
              {renderMenu(item.submenus)}
            </SubMenu>
          );
        }
        return (
          <Menu.Item
            key={item.key}
            onClick={() => item.path && (window.location.href = item.path)}
            style={{ cursor: item.path ? "pointer" : "default" }}
          >
            {item.label}
          </Menu.Item>
        );
      });
  };

  const historyMenu = (
    <Menu>
      {history.slice(1).map((route, index) => (
        <Menu.Item key={index} onClick={() => (window.location.href = route)}>
          <Tooltip title={route}>{route}</Tooltip>
        </Menu.Item>
      ))}
      {history.length <= 1 && <Menu.Item disabled>No recent routes</Menu.Item>}
    </Menu>
  );

  const currentBranchLabel =
    branches.find((branch) => branch.key === selectedBranch)?.label ||
    selectedBranch;

  // Mobile menu drawer content
  const mobileMenuDrawer = (
    <Drawer
      title="Menu"
      placement="right"
      onClose={() => setIsMobileMenuOpen(false)}
      open={isMobileMenuOpen}
      width={280}
      bodyStyle={{ padding: 0 }}
    >
      <div style={{ padding: '16px 0' }}>
        <div style={{ padding: '0 16px 16px', borderBottom: '1px solid #f0f0f0' }}>
          <Space direction="vertical" style={{ width: '100%' }}>
            <Button
              type="text"
              icon={<UserOutlined />}
              block
              onClick={() => {
                navigate("/settings/profile");
                setIsMobileMenuOpen(false);
              }}
              style={{ textAlign: 'left', justifyContent: 'flex-start' }}
            >
              Profile
            </Button>

            <Button
              type="text"
              icon={<BellOutlined />}
              block
              onClick={() => {
                showDrawer();
                setIsMobileMenuOpen(false);
              }}
              style={{ textAlign: 'left', justifyContent: 'flex-start' }}
            >
              Notifications
            </Button>

            <Button
              type="text"
              icon={<StarOutlined />}
              block
              onClick={() => {
                setIsFavoritesOpen(true);
                setIsMobileMenuOpen(false);
              }}
              style={{ textAlign: 'left', justifyContent: 'flex-start' }}
            >
              Favorites ({favorites.length})
            </Button>

            {isDeveloperToolsManager && (
              <>
                <Button
                  type="text"
                  icon={<DatabaseOutlined />}
                  block
                  onClick={() => {
                    setIsDrawerOpen(true);
                    setIsMobileMenuOpen(false);
                  }}
                  style={{ textAlign: 'left', justifyContent: 'flex-start' }}
                >
                  Server Status
                </Button>

                <Button
                  type="text"
                  icon={<CodeOutlined />}
                  block
                  onClick={() => {
                    setIsCommandDrawerOpen(true);
                    setIsMobileMenuOpen(false);
                  }}
                  style={{ textAlign: 'left', justifyContent: 'flex-start' }}
                >
                  Commands
                </Button>
              </>
            )}

            <Button
              type="text"
              icon={<SettingOutlined />}
              block
              onClick={() => {
                navigate("/settings");
                setIsMobileMenuOpen(false);
              }}
              style={{ textAlign: 'left', justifyContent: 'flex-start' }}
            >
              Settings
            </Button>

            <Button
              type="text"
              icon={theme === "dark" ? <SunOutlined /> : <MoonOutlined />}
              block
              onClick={() => {
                toggleTheme();
                setIsMobileMenuOpen(false);
              }}
              style={{ textAlign: 'left', justifyContent: 'flex-start' }}
            >
              {theme === "dark" ? "Light Mode" : "Dark Mode"}
            </Button>
          </Space>
        </div>

        <div style={{ padding: '16px' }}>
          <Button
            type="primary"
            danger
            icon={<LogoutOutlined />}
            block
            onClick={handleSignOut}
          >
            Logout
          </Button>
        </div>
      </div>
    </Drawer>
  );

  return (
    <>
      <Header
        style={{
          background: tenant?.theme?.colorPrimary ?? "#1890ff",
          padding: isMobile ? "0 12px" : "0 20px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          boxShadow: theme === "dark" 
            ? "0 2px 8px rgba(0, 0, 0, 0.45)" 
            : "0 2px 8px rgba(0, 0, 0, 0.08)",
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          zIndex: 101,
          height: isMobile ? "44px" : "48px",
        }}
      >
        {/* Left section */}
        <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
          {useV2Design && (
            <Tooltip title="Toggle Menu">
              <Button
                type="text"
                icon={<MenuOutlined />}
                onClick={onMenuClick}
                style={{
                  color: "white",
                  fontSize: "18px",
                  width: "32px",
                  height: "32px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  borderRadius: "6px",
                  backgroundColor: "rgba(255, 255, 255, 0.1)",
                  border: "none",
                  padding: 0,
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = "rgba(255, 255, 255, 0.2)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = "rgba(255, 255, 255, 0.1)";
                }}
              />
            </Tooltip>
          )}

          {/* Brand and Tenant Info */}
          <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
            {tenant.tenantLogo && (
              <img
                src={tenant.tenantLogo}
                alt={tenant.brandName || "Logo"}
                style={{
                  height: "28px",
                  width: "auto",
                  objectFit: "contain",
                }}
              />
            )}
            {isDesktop && (
              <>
                <div
                  style={{
                    width: "1px",
                    height: "24px",
                    backgroundColor: "rgba(255, 255, 255, 0.3)",
                  }}
                />
                <div style={{ display: "flex", flexDirection: "column", lineHeight: "1.2" }}>
                  <span style={{
                    color: "white",
                    fontSize: "14px",
                    fontWeight: 600,
                    letterSpacing: "0.3px",
                  }}>
                    {tenant.brandName || "Banklingo"}
                  </span>
                  {tenantInformation?.tenantName && (
                    <span style={{
                      color: "rgba(255, 255, 255, 0.85)",
                      fontSize: "11px",
                      fontWeight: 400,
                    }}>
                      {tenantInformation.tenantName}
                      {tenantInformation?.tenantEnvironment && ` [${tenantInformation.tenantEnvironment}]`}
                    </span>
                  )}
                </div>
              </>
            )}
          </div>
        </div>

        {/* Right section - Actions */}
        <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
          <Space size={4}>
          {/* Desktop Navigation Icons */}
          {useV2Design && isDesktop && (
            <>
              {/* Global Search */}
              <div style={{ marginRight: "8px" }}>
                {searchExpanded ? (
                  <Search
                    placeholder="Search anything..."
                    prefix={<SearchOutlined style={{ color: "#bfbfbf" }} />}
                    autoFocus
                    style={{ 
                      width: "280px",
                      borderRadius: "6px",
                    }}
                    onBlur={() => setSearchExpanded(false)}
                    onSearch={(value) => {
                      console.log("Search value:", value);
                      setSearchExpanded(false);
                    }}
                    allowClear
                  />
                ) : (
                  <Tooltip title="Search (Ctrl+K)">
                    <Button
                      type="text"
                      icon={<SearchOutlined />}
                      onClick={() => setSearchExpanded(true)}
                      style={getModernButtonStyle()}
                      onMouseEnter={(e) => handleButtonHover(e, true)}
                      onMouseLeave={(e) => handleButtonHover(e, false)}
                    />
                  </Tooltip>
                )}
              </div>

              {/* Navigator */}
              <Tooltip title="Navigator">
                <Button
                  type="text"
                  icon={<AppstoreOutlined />}
                  onClick={() => setIsNavigatorOpen(!isNavigatorOpen)}
                  style={getModernButtonStyle(isNavigatorOpen)}
                  data-active={isNavigatorOpen}
                  onMouseEnter={(e) => handleButtonHover(e, true)}
                  onMouseLeave={(e) => handleButtonHover(e, false)}
                />
              </Tooltip>

              {/* Favorites with Badge */}
              <Popover
                content={favoritesContent}
                title={null}
                trigger="hover"
                open={isFavoritesOpen && !isMobile}
                onOpenChange={setIsFavoritesOpen}
                placement="bottomRight"
                overlayStyle={{ zIndex: 1050 }}
                overlayInnerStyle={{ padding: 0 }}
              >
                <div>
                  <Tooltip title={favorites.length > 0 ? `${favorites.length} favorites` : "Add to favorites"}>
                    <Badge count={favorites.length} size="small" offset={[-2, 2]}>
                      <Button
                        type="text"
                        icon={<StarOutlined />}
                        onClick={handleAddToFavorites}
                        style={{
                          ...getModernButtonStyle(favorites.length > 0),
                          backgroundColor: favorites.length > 0 ? 'rgba(255, 215, 0, 0.2)' : 'transparent',
                        }}
                        data-active={favorites.length > 0}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.backgroundColor = favorites.length > 0 
                            ? 'rgba(255, 215, 0, 0.3)' 
                            : "rgba(255, 255, 255, 0.15)";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.backgroundColor = favorites.length > 0 
                            ? 'rgba(255, 215, 0, 0.2)' 
                            : "transparent";
                        }}
                      />
                    </Badge>
                  </Tooltip>
                </div>
              </Popover>

              {/* Notifications with Badge */}
              <Tooltip title="Notifications">
                <Badge count={5} size="small" offset={[-2, 2]}>
                  <Button
                    type="text"
                    icon={<BellOutlined />}
                    onClick={showDrawer}
                    style={getModernButtonStyle()}
                    onMouseEnter={(e) => handleButtonHover(e, true)}
                    onMouseLeave={(e) => handleButtonHover(e, false)}
                  />
                </Badge>
              </Tooltip>

              {/* Developer Tools (conditional) */}
              {isDeveloperToolsManager && (
                <>
                  <Tooltip title="Server Status">
                    <Button
                      type="text"
                      icon={<DatabaseOutlined />}
                      onClick={() => setIsDrawerOpen(true)}
                      style={getModernButtonStyle()}
                      onMouseEnter={(e) => handleButtonHover(e, true)}
                      onMouseLeave={(e) => handleButtonHover(e, false)}
                    />
                  </Tooltip>

                  <Tooltip title="Commands">
                    <Button
                      type="text"
                      icon={<CodeOutlined />}
                      onClick={() => setIsCommandDrawerOpen(true)}
                      style={getModernButtonStyle()}
                      onMouseEnter={(e) => handleButtonHover(e, true)}
                      onMouseLeave={(e) => handleButtonHover(e, false)}
                    />
                  </Tooltip>
                </>
              )}

              {/* Divider */}
              <div
                style={{
                  width: "1px",
                  height: "24px",
                  backgroundColor: "rgba(255, 255, 255, 0.2)",
                  margin: "0 8px",
                }}
              />
            </>
          )}
          </Space>
        </div>

        {/* Right section */}
        <div style={{ display: "flex", alignItems: "center" }}>
          <Space size={isMobile ? "small" : "middle"}>
            {/* Mobile Search */}
            {isMobile && (
              <>
                {isSearchMobile ? (
                  <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    backgroundColor: 'rgba(255, 255, 255, 0.1)',
                    borderRadius: '4px',
                    padding: '4px'
                  }}>
                    <Search
                      placeholder="Search..."
                      autoFocus
                      style={{ width: "160px" }}
                      onBlur={handleSearchBlur}
                      onSearch={(value) => {
                        console.log("Search value:", value);
                        setIsSearchMobile(false);
                      }}
                    />
                    <Button
                      type="text"
                      icon={<CloseOutlined />}
                      style={{ color: "white" }}
                      onClick={() => setIsSearchMobile(false)}
                    />
                  </div>
                ) : (
                  <Tooltip title="Search">
                    <Button
                      type="text"
                      icon={<SearchOutlined />}
                      style={{
                        color: "white",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        height: "32px",
                      }}
                      onClick={handleSearchToggle}
                    />
                  </Tooltip>
                )}
              </>
            )}

            {/* Desktop Language Selector */}
            {useV2Design && !!serverLanguages.length && isDesktop && (
              <Dropdown
                menu={{
                  items: serverLanguages.map((language) => ({
                    key: language?.code?.toLowerCase(),
                    label: language?.name,
                  })),
                  onClick: handleLanguageChange,
                }}
                placement="bottomRight"
                trigger={["click"]}
              >
                <Button
                  style={{
                    backgroundColor: "rgba(255, 255, 255, 0.1)",
                    borderColor: "rgba(255, 255, 255, 0.3)",
                    color: "white",
                    display: "flex",
                    alignItems: "center",
                    height: "32px",
                    padding: "0 12px",
                    borderRadius: "4px",
                    fontSize: "14px",
                    whiteSpace: "nowrap",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor =
                      "rgba(255, 255, 255, 0.2)";
                    e.currentTarget.style.borderColor =
                      "rgba(255, 255, 255, 0.5)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor =
                      "rgba(255, 255, 255, 0.1)";
                    e.currentTarget.style.borderColor =
                      "rgba(255, 255, 255, 0.3)";
                  }}
                >
                  <span style={{ marginRight: "8px", maxWidth: "80px", overflow: "hidden", textOverflow: "ellipsis" }}>
                    {serverLanguages.find((lng) => lng?.code === language)?.name}
                  </span>
                  <DownOutlined style={{ fontSize: "12px", flexShrink: 0 }} />
                </Button>
              </Dropdown>
            )}

            {/* Desktop Branch Selector */}
            {useV2Design && isDesktop && (
              <Dropdown
                overlay={branchMenu}
                placement="bottomRight"
                trigger={["click"]}
              >
                <Button
                  style={{
                    backgroundColor: "rgba(255, 255, 255, 0.15)",
                    borderColor: "transparent",
                    color: "white",
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    height: "32px",
                    padding: "0 12px",
                    borderRadius: "6px",
                    fontSize: "13px",
                    fontWeight: 500,
                    whiteSpace: "nowrap",
                    border: "1px solid rgba(255, 255, 255, 0.2)",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = "rgba(255, 255, 255, 0.25)";
                    e.currentTarget.style.borderColor = "rgba(255, 255, 255, 0.35)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = "rgba(255, 255, 255, 0.15)";
                    e.currentTarget.style.borderColor = "rgba(255, 255, 255, 0.2)";
                  }}
                >
                  {isLoadingBranches ? (
                    <LoadingOutlined />
                  ) : (
                    <>
                      <span style={{
                        maxWidth: "150px",
                        overflow: "hidden",
                        textOverflow: "ellipsis"
                      }}>
                        {currentBranchLabel}
                      </span>
                      <DownOutlined style={{ fontSize: "11px" }} />
                    </>
                  )}
                </Button>
              </Dropdown>
            )}

            {/* Divider */}
            <div
              style={{
                width: "1px",
                height: "24px",
                backgroundColor: "rgba(255, 255, 255, 0.2)",
                margin: "0 4px 0 8px",
              }}
            />

            {/* Desktop Search */}
            {useV2Design && isDesktop && (
              <div style={{ display: "flex", alignItems: "center" }}>
                {searchExpanded ? (
                  <Search
                    placeholder="Search..."
                    autoFocus
                    style={{ width: "200px" }}
                    onBlur={handleSearchBlur}
                    onSearch={(value) => {
                      console.log("Search value:", value);
                      setSearchExpanded(false);
                    }}
                  />
                ) : (
                  <Tooltip title="Search">
                    <Button
                      type="text"
                      icon={<SearchOutlined />}
                      style={{
                        color: "white",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        height: "32px",
                      }}
                      onClick={handleSearchToggle}
                    />
                  </Tooltip>
                )}
              </div>
            )}

            {/* Mobile Menu Button */}
            {isMobile && (
              <Button
                type="text"
                icon={<MenuOutlined />}
                style={{ color: "white" }}
                onClick={() => setIsMobileMenuOpen(true)}
              />
            )}

            {/* Desktop User Menu */}
            {!isMobile && (
              <Dropdown overlay={userMenu} placement="bottomRight">
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                    color: "white",
                    height: "32px",
                  }}
                >
                  <Avatar
                    size="small"
                    style={{
                      backgroundColor:
                        tenant.theme.iconOutlineStyle?.color ?? "#52c41a",
                      marginRight: "8px",
                    }}
                    icon={<UserOutlined />}
                  />
                  {isDesktop && (
                    <DownOutlined style={{ fontSize: "12px" }} />
                  )}
                </div>
              </Dropdown>
            )}

            {/* Mobile User Avatar */}
            {isMobile && (
              <Avatar
                size="small"
                style={{
                  backgroundColor:
                    tenant.theme.iconOutlineStyle?.color ?? "#52c41a",
                  cursor: "pointer",
                }}
                icon={<UserOutlined />}
                onClick={() => setIsMobileMenuOpen(true)}
              />
            )}
          </Space>
        </div>
      </Header>

      {/* Mobile Menu Drawer */}
      {mobileMenuDrawer}

      {/* Mobile Favorites Drawer */}
      {mobileFavoritesDrawer}

      {/* Mobile search overlay */}
      {isMobile && isSearchMobile && (
        <div
          style={{
            position: "fixed",
            top: 44,
            left: 0,
            right: 0,
            backgroundColor: tenant?.theme?.colorPrimary ?? "#1890ff",
            padding: "8px",
            zIndex: 1000,
            boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
          }}
        >
          <div style={{ display: "flex", alignItems: "center" }}>
            <Search
              placeholder="Search..."
              autoFocus
              style={{ flex: 1 }}
              onBlur={handleSearchBlur}
              onSearch={(value) => {
                console.log("Search value:", value);
                setIsSearchMobile(false);
              }}
              enterButton
            />
            <Button
              type="text"
              icon={<CloseOutlined />}
              style={{ color: "white", marginLeft: "8px" }}
              onClick={() => setIsSearchMobile(false)}
            />
          </div>
        </div>
      )}

      {isModalOpen && <LanguageSwitcher />}
      <CountrySupportModal
        isModalOpen={isOpen}
        handleOkay={() => setIsOpen(false)}
        handleCancel={() => setIsOpen(false)}
      />
      <CommandDrawer
        visible={isCommandDrawerOpen}
        onClose={() => setIsCommandDrawerOpen(false)}
      />
      <ServerStatusDrawer
        visible={isDrawerOpen}
        onClose={() => setIsDrawerOpen(false)}
      />
      <NotificationDrawer
        open={open}
        onClose={onClose}
        showDrawer={showDrawer}
      />
      <NavigatorModal
        isNavigatorOpen={isNavigatorOpen}
        setIsNavigatorOpen={setIsNavigatorOpen}
      />

      {/* Edit Favorite Modal */}
      {editFavoriteModal}
    </>
  );
};

export default DashboardHeader;